import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnrichError } from '../../models/error';
import { EnrichErrorType } from '../../models/error-type.enum';
import { User } from '../models/user.model';
import { AuthenticationInfo } from '../models/authentication-info.model';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../environments/environment';
import * as jwt from 'jsonwebtoken';
import * as moment from 'moment';

@Injectable()
export class AuthenticationService {
  private _authenticationInfo: BehaviorSubject<AuthenticationInfo>;
  public get authenticationInfo(): Observable<AuthenticationInfo> {
    return this._authenticationInfo.skipWhile(authenticationInfo => authenticationInfo === undefined);
  }

  constructor(
    private httpClient: HttpClient,
  ) {
    this._authenticationInfo = new BehaviorSubject<AuthenticationInfo>(undefined);
    let error: EnrichError;
    Observable.of(localStorage.getItem('JWT_TOKEN')).flatMap(token => {
      let expiration = token ? moment.unix(jwt.decode(token).exp) : null;
      if (expiration && expiration.isBefore()) {
        error = new EnrichError(EnrichErrorType.CREDENTIALS_EXPIRED);
      }

      if (!token || expiration.isBefore()) {
        return Observable.of(null);
      }
      return this.httpClient.get(`${environment.baseUrl}/api/user`);
    }).subscribe((authenticationInfo: AuthenticationInfo) => {
      if (authenticationInfo !== null) {
        let jwtToken = localStorage.getItem('JWT_TOKEN');
        this.setAuthenticationInfo(authenticationInfo.user, jwtToken);
      } else {
        this.setAuthenticationInfo(null, null, error);
      }
    });
  }

  public login(email: string, password: string): Observable<boolean | any> {
    let loginUrl = `${environment.baseUrl}/auth/login`;
    let loginBody = { email, password };
    let currentUserUrl = `${environment.baseUrl}/api/user`;

    let jwtToken: string;
    return this.httpClient.post(loginUrl, loginBody)
      .flatMap((authenticationInfo: AuthenticationInfo) => {
        jwtToken = authenticationInfo.token;
        localStorage.setItem('JWT_TOKEN', jwtToken);
        return this.httpClient.get(currentUserUrl);
      })
      .map((authenticationInfo: AuthenticationInfo) => {
        this.setAuthenticationInfo(authenticationInfo.user, jwtToken);
        return { error: false };
      })
      .catch(() => {
        return Observable.of({
          error: true,
          message: 'Invalid credentials',
        });
      });
  }

  public logout(): void {
    localStorage.removeItem('JWT_TOKEN');
    this.setAuthenticationInfo(null, null);
  }

  public impersonate(user: User): Observable<boolean> {
    let url = `${environment.baseUrl}/api/users/${user.id}/impersonate`;
    return this.httpClient.post(url, null)
      .map((authenticationInfo: AuthenticationInfo) => {
        localStorage.setItem('JWT_TOKEN', authenticationInfo.token);
        this._authenticationInfo.next(authenticationInfo);
        return true;
      });
  }

  private setAuthenticationInfo(user: User, token: string, error: EnrichError = null): void {
    this._authenticationInfo.next({ token, user, error });
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/auth/authentication.service.ts